import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface ChatPanelState {
  isChatOpen: boolean
  isFullscreen: boolean
  /** Which screen edge the panel slides in from. */
  side: 'left' | 'right'
  openChat: () => void
  closeChat: () => void
  toggleChat: () => void
  toggleFullscreen: () => void
  setSide: (side: 'left' | 'right') => void
  toggleSide: () => void
}

export const useChatPanel = create<ChatPanelState>()(
  persist(
    (set) => ({
      isChatOpen: true, // Default to open on desktop
      isFullscreen: false,
      side: 'right',
      openChat: () => set({ isChatOpen: true }),
      closeChat: () => set({ isChatOpen: false }),
      toggleChat: () => set((state) => ({ isChatOpen: !state.isChatOpen })),
      toggleFullscreen: () => set((state) => ({
        isFullscreen: !state.isFullscreen,
        isChatOpen: true,
      })),
      setSide: (side) => set({ side }),
      toggleSide: () => set((state) => ({ side: state.side === 'right' ? 'left' : 'right' })),
    }),
    {
      name: 'chat-panel-state',
    }
  )
)

// Keep the old export for backward compatibility
export const useMobileMenu = useChatPanel
